import { useContext } from "react";
import { LoadingDispatchContext } from "../SimulationProvider";

export const useLoadingDispatch = () => {
  const dispatcher = useContext(LoadingDispatchContext);
  if (!dispatcher) throw new Error("LoadingDispatchContext not found");

  return dispatcher;
};
